import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/src/app/terms/_components/TermsPage.tsx");
